import { getDate } from 'date-fns';
import {
  MonthAvailability,
  TimeIntervalTypeValues,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { getFirstInstanceDateUTC } from 'src/models/LineOfCreditModelUtils';
import { getDailyPeriodStartFromEndDay } from 'src/components/oneCorp/features/MealCredit/utils/getDailyPeriodStartFromEndDay';

export type MonthAvailabilityParams = {
  firstInstanceEndDateUtc: string | null;
  firstInstanceUtc: string;
  timeIntervalType: TimeIntervalTypeValues;
};

export const getInstanceMonthAvailability = ({
  firstInstanceEndDateUtc,
  firstInstanceUtc,
  timeIntervalType,
}: MonthAvailabilityParams): MonthAvailability => {
  if (firstInstanceEndDateUtc === null) {
    return MonthAvailability.EVERY_DAY;
  }

  const firstInstanceEndDate = getDate(
    getDailyPeriodStartFromEndDay(
      getFirstInstanceDateUTC(firstInstanceEndDateUtc),
      timeIntervalType
    )
  );
  const firstInstanceDate = getDate(getFirstInstanceDateUTC(firstInstanceUtc));

  if (firstInstanceEndDate === firstInstanceDate) {
    return MonthAvailability.ON_SPECIFIC_DAY;
  }

  return MonthAvailability.WITHIN_DATE_RANGE;
};
